/*
 * @package           Zorg CMS
 * @author            Chalda
 * @copyright         Copyright (c) 2008 - 2019, Belder Interactive s.a.s.
 * @link              https://www.belder.com
 * @version           3.2
 */

function increaseFontSize(inout) {
	$('nav a, *[class*=u-text-],.Prose *, footer *').each(function (i, el) {
		var style       = window.getComputedStyle(el, null).getPropertyValue('font-size');
		var currentSize = parseFloat(style);
		if (inout) {
			el.setAttribute('style', 'font-size: ' + (currentSize + 3) + 'px !important');
		} else {
			el.removeAttribute('style');
		}
	})
}

import $ from 'jquery'

var fn_font = JSON.parse(localStorage.getItem('fn_font'));
if (fn_font) increaseFontSize(fn_font);

$('#fn_font').on('click', function () {
	fn_font = !fn_font;
	localStorage.setItem('fn_font', fn_font);
	increaseFontSize(fn_font);
});

var fn_contrast = JSON.parse(localStorage.getItem('fn_contrast'));
if (fn_contrast) $('body').addClass('contrast');
$('#fn_contrast').on('click', function () {
	fn_contrast = !fn_contrast;
	localStorage.setItem('fn_contrast', fn_contrast);
	$('body')[fn_contrast ? 'addClass' : 'removeClass']('contrast');
});

var fn_link = JSON.parse(localStorage.getItem('fn_link'));
if (fn_link) $('body').addClass('link');
$('#fn_link').on('click', function () {
	fn_link = !fn_link;
	localStorage.setItem('fn_link', fn_link);
	$('body')[fn_link ? 'addClass' : 'removeClass']('link');
});



// WEBPACK FOOTER //
// ./src/themes/pac/js/contrast.js